import { createFileRoute } from "@tanstack/react-router";

import { CurrentLiabilities } from "~/components/feature/balance/components";

export const Route = createFileRoute(
  "/_app/dashboard/balance/current-liabilities/",
)({
  component: RouteComponent,
});

function RouteComponent() {
  return <CurrentLiabilities />;
}
